// Routes can resolve with a trailing slash (`/en-us/maps/?near=...`) or mixed case,
// so compare against a canonical form instead of the raw pathname.
const normalizePathname = (pathname) => {
  if (!pathname || typeof pathname !== 'string') return '';
  return pathname.toLowerCase().replace(/\/+$/, '') || '/';
};

export default normalizePathname;
